import React, { useEffect, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Text } from "../../components";
import Styled from "./styled";
import { Flex } from "antd";

const Collapse = ({
  children,
  title = "",
  panelStyle,
  done = false,
  disable = false,
  ...props
} = {}) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(props.active);
  }, [props.active]);

  return (
    <Styled active={active}>
      <Flex gap={"1.5rem"} onClick={() => !disable && setActive((_) => !_)}>
        <Text disabled={disable} className="m-3-t" level={5} color="secondary">
          <DownOutlined className="icon" />
        </Text>
        <Text
          level={4}
          weight={700}
          children={title}
          disabled={disable}
          color="secondary"
          unselectable="on"
          lineHeight="normal"
        />
      </Flex>
      <div children={children} className="content" />
    </Styled>
  );
};

export default Collapse;
